import { Badge } from './ui';
import { useTooltip } from './ui/Tooltip';

export const LATE_LABEL = 'Late (after answers)';
export const LATE_TOOLTIP = 'Submitted after answers were released — not counted in class averages';
export const LATE_UNVERIFIED_TOOLTIP = "Taken time couldn't be verified";

/** A result the student submitted after the exam's answer key was released (`late`);
 *  not the task tracker's "late" (after the due date). `unverified` (`late_unverified`):
 *  the phone could not prove when the exam was taken, so it counted as after release.
 *  Screen readers get the explanation once, from the sr-only text (the tooltip is
 *  visual only, with no aria-describedby). */
export default function LateBadge({ className = '', unverified = false }: { className?: string; unverified?: boolean }) {
  const text = unverified ? `${LATE_TOOLTIP}. ${LATE_UNVERIFIED_TOOLTIP}.` : LATE_TOOLTIP;
  const { ref, triggerProps, tooltip } = useTooltip<HTMLSpanElement>(<span aria-hidden="true">{text}</span>);
  const visualOnly = { ...triggerProps, 'aria-describedby': undefined };
  return (
    <>
      <span ref={ref} tabIndex={0} {...visualOnly}
        className={`inline cursor-help rounded-sm no-underline outline-none focus-visible:ring-2 focus-visible:ring-primary ${className}`}>
        <Badge tone="warning" size="sm" className="align-middle">
          {LATE_LABEL}<span className="sr-only">: {text}</span>
        </Badge>
      </span>
      {tooltip}
    </>
  );
}
